import React, { useState } from "react";
import MaterialExTable from "../../../../components/tables/MaterialExTable";
import TableFilters from "./TableFilters";
import useGetEmailLogs from "./hooks/useEmailLogs";
import ShowButton from "../../../../components/ShowButton";
import Modal from "../../../../components/Modal";
import EmailLogsModalTable from "./EmailLogsModalTable";
import RequeueButton from "../../../../components/RequeueButton";
import useRequeueEmail from "./hooks/useRequeueEmail";
import { useQueryClient } from "react-query";
import { toast } from "../../../../components/toastNotification";
import { paginationData } from "../../../CarrierAgreementMgmt/atoms";
import { useRecoilState } from "recoil";
//import { paginationData } from "../../../atoms";
const EmailLogsTable = () => {
  //user permissions
  const { data: emailLogsData, isFetching } = useGetEmailLogs();
  const { mutateAsync: RequeueEmail } = useRequeueEmail();
  const [emailLogData, setEmailLogData] = useState([]);
  // const [, setFilterText] = useState("");
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [, setemailLogsDetails] = useState();
  const queryClient = useQueryClient();
  const [isRequeue, setIsRequeue] = useState(false);

  const [emailLogsFilteredData, setEmailLogsFilteredData] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [page, setPage] = useRecoilState(paginationData);

  const filteredItems = emailLogsData?.filter(
    (item) =>
      item.sourceActivity
        ?.toLowerCase()
        ?.includes(filterText?.trim().toLowerCase()) ||
      item.moduleName
        ?.toLowerCase()
        ?.includes(filterText?.trim().toLowerCase()) ||
      item.sender?.toLowerCase().includes(filterText?.trim().toLowerCase()) ||
      item.emailStatus
        ?.toLowerCase()
        ?.includes(filterText?.trim().toLowerCase())
  );

  //columns
  const matColumns = [
    {
      title: "Source Activity",
      field: "sourceActivity",
      render: (rowData) => {
        return <>{rowData.sourceActivity}</>;
      },
    },
    {
      title: "Module Name",
      field: "moduleName",
      render: (rowData) => {
        return <>{rowData.moduleName}</>;
      },
    },
    {
      title: "Status",
      field: "emailStatus",
      render: (rowData) => {
        return <>{rowData.emailStatus}</>;
      },
    },
    {
      title: "Record Id",
      field: "recordId",
      render: (rowData) => {
        return <>{rowData.recordId}</>;
      },
    },
    {
      title: "Sender",
      field: "sender",
      render: (rowData) => {
        return <>{rowData.sender}</>;
      },
    },
    {
      title: "Created By",
      field: "createdBy",
      render: (rowData) => {
        return <>{rowData.createdBy}</>;
      },
    },
    {
      title: "Created Date",
      field: "createdDate",
      render: (rowData) => {
        return (
          <>
            {rowData.createdDate
              ? new Date(rowData.createdDate).toLocaleDateString()
              : "unspecified"}
          </>
        );
      },
    },
    {
      title: "Action/s",
      field: "",
      align: "center",
      render: (rowData) => {
        return (
          <div className="flex items-center place-content-center mr-5">
            <ShowButton
              className={"opacity-100"}
              disabled={false}
              buttonText="Show"
              onClick={() => {
                handleActions(rowData, "Show");
              }}
            />
          </div>
        );
      },
    },
  ];
  const handleActions = (rowData) => {
    setIsOpenModal(true);
    setEmailLogData(rowData);
  };
  const handleRequeue = (rowData) => {
    setIsRequeue(true);
    RequeueEmail(rowData, {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          queryClient.invalidateQueries(["GetEmailLogs"]);
          setIsRequeue(false);
          toast.fire("Success", "Email requeued successfully", "success");
          setIsOpenModal(false);
        } else {
          setIsRequeue(false);
          toast.fire("Failed", "Failed to requeue email", "error");
          setIsOpenModal(false);
        }
      },
      onError: (error) => {
        setIsOpenModal(false);
        toast.fire("Failed", "Failed to requeue email", "error");
      },
    });
  };
  return (
    <div className="animate-fade-in-down">
      <div className="font-bold text-primary text-xl uppercase py-4">
        {/* Email Logs */}
      </div>
      <div className="">
        <div className="w-full">
          <div className="flex flex-row justify-between">
            <div className="flex flex-row item-center ml-4 -mt-4 space-x-2">
              <TableFilters
                setIsSearching={setIsSearching}
                setFilterText={setFilterText}
                moduleDetails="Source Activity"
                textInputName="emailLogs"
                disabledButton={false}
              />
            </div>
          </div>
          <div className="m-4 rounded-md box-shadow border-t overflow-x-auto">
            <MaterialExTable
              columns={matColumns}
              data={isSearching ? filteredItems : emailLogsData}
              options={{
                toolbar: false,
                showTitle: false,
                initialPage: page,
              }}
              isLoading={isFetching}
              selection={false}
              setOpenModal={false}
              isDeactivate={true}
              selectableRowDisabled={false}
            />
          </div>
        </div>
      </div>
      {isOpenModal && (
        <Modal
          isCloseHide={false}
          modalFilterStat=""
          className=""
          width={"100"}
          title={""}
          isOpen={isOpenModal}
          onClose={() => {
            setIsOpenModal(false);
          }}
          hasCloseButton={false}
        >
          <div className="grid grid-cols-4 p-2">
            <label className="text-xs text-gray-700 text-left ml-2">
              Source Activity:
            </label>
            <div className="expandedData fontExpand">
              {emailLogData.sourceActivity}
            </div>
            <label className="text-xs text-gray-700 text-left ml-6">
              Email Activity Id:
            </label>
            <div className=" expandedData fontExpand">{emailLogData.id}</div>
          </div>
          <div className="grid grid-cols-4 p-2">
            <label className="text-xs text-gray-700 text-left ml-2">
              Status:
            </label>
            <div className="expandedData fontExpand">
              {emailLogData.emailStatus}
            </div>
            <label className="text-xs text-gray-700 text-left ml-6">
              Sender:
            </label>
            <div className="expandedData fontExpand">{emailLogData.sender}</div>
          </div>
          <div className="grid grid-cols-4 p-2">
            <label className="text-xs text-gray-700 text-left ml-2">
              Module Name:
            </label>
            <div className="expandedData fontExpand">
              {emailLogData.moduleName}
            </div>
          </div>
          <div className="mb-1 mt-2 w-full border-b-2 borderSecondary my-2"></div>
          {emailLogData.emailStatus === "Failed" ? (
            <div className="flex justify-end mt-2">
              <RequeueButton
                className={"opacity-100"}
                disabled={false}
                buttonText={isRequeue ? "Requeuing..." : "Requeue"}
                onClick={() => {
                  handleRequeue(emailLogData);
                }}
              />
            </div>
          ) : (
            ""
          )}
          <div>
            {emailLogData.emailStatus === "Failed" ? (
              <div className="-mt-8"></div>
            ) : (
              ""
            )}
            <EmailLogsModalTable
              emailLogsDetails={emailLogData}
              setemailLogsDetails={setemailLogsDetails}
            />
          </div>
        </Modal>
      )}
    </div>
  );
};
export default EmailLogsTable;
